import { searchApi, skipToken } from '@tunasong/redux'
import type { SearchFilter } from '@tunasong/schemas'
import { searchTotal } from '@tunasong/schemas'
import { useDelayedValue } from '@tunasong/ui-lib'
import { allQueries } from './queries/index.js'

/** "{n} more in other spaces" (#2555): shown only when both totals are known and some are elsewhere */
export const otherSpacesCount = ({ everywhere, scoped }: { everywhere?: number; scoped?: number }) => {
  if (everywhere === undefined || scoped === undefined) {
    return undefined
  }
  const more = everywhere - scoped
  return more > 0 ? more : undefined
}

export interface OtherSpacesCountProps {
  /** Only while search is scoped to a space and something is typed */
  enabled: boolean
  query: string
  filter?: SearchFilter
  /** The scoped search's total */
  scopedTotal?: number
  debounceDelay?: number
}

/**
 * The matches outside the space, for the scoped footer (#2555). One count-only request (`size: 0`) per settled query,
 * debounced like the search itself, and only while scoped (Brian, 2026-10-22).
 */
export const useOtherSpacesCount = (props: OtherSpacesCountProps) => {
  const { enabled, query, filter, scopedTotal, debounceDelay = 200 } = props
  const spec = enabled && query ? allQueries.default({ query, size: 0, filter }) : undefined
  const settled = useDelayedValue(spec, debounceDelay)
  const { currentData } = searchApi.useSearchQuery(
    settled
      ? {
          query: { ...settled, from: 0, size: 0 },
          queryType: 'default',
          intent: { query, size: 0, types: filter?.types, tags: filter?.tags },
        }
      : skipToken
  )
  return otherSpacesCount({ everywhere: enabled ? searchTotal(currentData) : undefined, scoped: scopedTotal })
}
